import { useQuery } from "@tanstack/react-query";

import { medicationRequestQueriesStore } from "@/features/my-meds/api";

export const useCurrentMedicationRequests = () => {
  return useQuery(
    medicationRequestQueriesStore.medicationRequest.list._ctx.current,
  );
};
